import { SET_APP } from './actionTypes'
import { AppActionTypes, EAppVersion } from './types'

const initialState = {
  version: (window as any).InstantOfferAppVersion || EAppVersion.a,
  step: 0, 
  subStep: 0,
  isLoading: false, 
  back: '/sellmycar', 
  offerDate: '', 
  expiry: '', 
  offerId: 0
}

export default (state = initialState, action: AppActionTypes) => {
  switch (action.type) {
    case SET_APP:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
